export default {
  props: {
    column: {
      type: Object,
      required: true
    },
    columnIndex: {
      type: Number,
      required: true
    },
    board: {
      type: Object,
      required: true
    }
  },
  methods: {
    moveCampo ({ fromColumnIndex, fromTaskIndex }) {
      // const fromTasks = this.board.columns[fromColumnIndex].tasks

      this.$store.commit('MOVE_CAMPO', {
        fromTasks :this.board.columns[fromColumnIndex].campos,
        fromTaskIndex,
        toTasks: this.column.campos,
        toTaskIndex: this.camposIndex,
        fromColumn: this.board.columns[fromColumnIndex].name,
        toColumn : this.column.name
      })
 
    },
  }
}
